// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lx-online-booking-quote-form__message-preview-col[data-v-2cc8a1b2]{text-align:-webkit-center}.lx-online-booking-quote-form__message-preview-message[data-v-2cc8a1b2]{text-align:left;max-width:562px}.lx-online-booking-quote-form[data-v-2cc8a1b2] .card-body{padding-bottom:0px !important}", ""]);
// Exports
module.exports = exports;
